import React from 'react';
import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom';

const AutomotiveFleetUseCase = () => {
  return (
    <section className="py-24 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
      <div className="max-w-7xl mx-auto">
        <div 
          className="rounded-xl p-8 md:p-12"
          style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            
            {/* Left Column - Text Content */}
            <div className="flex flex-col justify-center">
              <div 
                className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-xs font-semibold uppercase tracking-wider mb-6 w-fit"
                style={{ backgroundColor: 'transparent', border: '1px solid #F5CB5C', color: '#F5CB5C' }}
              >
                Automotive
              </div>

              <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
                Fleet Management
              </h2>

              <p className="text-base mb-4" style={{ color: '#9CA3AF' }}>
                For large OEMs and SDV programs (e.g., VW Cariad)
              </p>

              <p className="text-base leading-relaxed mb-8" style={{ color: '#9CA3AF' }}>
                Orchestrate hundreds of test vehicles across global validation programs with real-time telemetry, automated resource scheduling, and intelligent failure triage. Sleeve unifies fleet coordination, OTA rollout management, and CI/CD integration—delivering operational efficiency at scale for software-defined vehicle development.
              </p>

              <Link 
                to="/use-cases/automotive-fleet-management"
                className="inline-flex items-center gap-2 text-base font-medium transition-colors duration-250 w-fit"
                style={{ color: '#4FB3B8' }}
              >
                View Use Case
                <Icon name="ArrowRight" size={16} style={{ color: '#4FB3B8' }} />
              </Link>
            </div>

            {/* Right Column - Diagram */}
            <div className="flex items-center justify-center">
              <div 
                className="w-full rounded-lg p-6"
                style={{ backgroundColor: '#242423', border: '1px solid #3A3A38' }}
              >
                <svg width="100%" height="340" viewBox="0 0 480 340" className="max-w-full">
                  
                  {/* Global Test Fleet Header */}
                  <text x="240" y="25" textAnchor="middle" fill="#9CA3AF" fontSize="11" fontWeight="600" letterSpacing="1">GLOBAL TEST FLEET</text>
                  
                  {/* Top Row - EMEA, AMERICAS, APAC */}
                  <rect x="40" y="45" width="110" height="55" rx="6" fill="#242423" stroke="#F5CB5C" strokeWidth="2" />
                  <text x="95" y="70" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600">EMEA</text>
                  <text x="95" y="85" textAnchor="middle" fill="#9CA3AF" fontSize="10">127 Vehicles</text>
                  
                  <rect x="185" y="45" width="110" height="55" rx="6" fill="#242423" stroke="#3A3A38" strokeWidth="2" />
                  <text x="240" y="70" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600">AMERICAS</text>
                  <text x="240" y="85" textAnchor="middle" fill="#9CA3AF" fontSize="10">84 Vehicles</text>
                  
                  <rect x="330" y="45" width="110" height="55" rx="6" fill="#242423" stroke="#F5CB5C" strokeWidth="2" />
                  <text x="385" y="70" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600">APAC</text>
                  <text x="385" y="85" textAnchor="middle" fill="#9CA3AF" fontSize="10">93 Vehicles</text>
                  
                  {/* Connection lines from top row to orchestration */}
                  <line x1="95" y1="100" x2="95" y2="130" stroke="#3A3A38" strokeWidth="1.5" />
                  <line x1="95" y1="130" x2="240" y2="130" stroke="#3A3A38" strokeWidth="1.5" />
                  
                  <line x1="240" y1="100" x2="240" y2="155" stroke="#3A3A38" strokeWidth="1.5" />
                  
                  <line x1="385" y1="100" x2="385" y2="130" stroke="#3A3A38" strokeWidth="1.5" />
                  <line x1="385" y1="130" x2="240" y2="130" stroke="#3A3A38" strokeWidth="1.5" />
                  
                  {/* Sleeve Fleet Orchestration Box */}
                  <rect x="70" y="155" width="340" height="70" rx="6" fill="#242423" stroke="#F5CB5C" strokeWidth="2" />
                  <text x="240" y="185" textAnchor="middle" fill="#E8EDDF" fontSize="12" fontWeight="700">SLEEVE FLEET ORCHESTRATION</text>
                  <text x="240" y="205" textAnchor="middle" fill="#9CA3AF" fontSize="9">Resource Scheduling • OTA Management • Failure Triage • CI/CD Integration</text>
                  
                  {/* Connection lines from orchestration to bottom circles */}
                  <line x1="240" y1="225" x2="240" y2="255" stroke="#3A3A38" strokeWidth="1.5" />
                  <line x1="95" y1="255" x2="385" y2="255" stroke="#3A3A38" strokeWidth="1.5" />
                  
                  {/* Vertical lines to bottom nodes */}
                  <line x1="95" y1="255" x2="95" y2="275" stroke="#3A3A38" strokeWidth="1.5" />
                  <line x1="190" y1="255" x2="190" y2="275" stroke="#3A3A38" strokeWidth="1.5" />
                  <line x1="290" y1="255" x2="290" y2="275" stroke="#3A3A38" strokeWidth="1.5" />
                  <line x1="385" y1="255" x2="385" y2="275" stroke="#3A3A38" strokeWidth="1.5" />
                  
                  {/* Bottom Row - Circles */}
                  {/* OTA */}
                  <circle cx="95" cy="295" r="22" fill="#242423" stroke="#3A3A38" strokeWidth="2" />
                  <text x="95" y="299" textAnchor="middle" fill="#E8EDDF" fontSize="10" fontWeight="600">OTA</text>
                  <text x="95" y="330" textAnchor="middle" fill="#9CA3AF" fontSize="9">Rollout</text>
                  
                  {/* TELEM */}
                  <circle cx="190" cy="295" r="22" fill="#242423" stroke="#3A3A38" strokeWidth="2" />
                  <text x="190" y="299" textAnchor="middle" fill="#E8EDDF" fontSize="10" fontWeight="600">TELEM</text>
                  <text x="190" y="330" textAnchor="middle" fill="#9CA3AF" fontSize="9">Analytics</text>
                  
                  {/* CI/CD */}
                  <circle cx="290" cy="295" r="22" fill="#242423" stroke="#3A3A38" strokeWidth="2" />
                  <text x="290" y="299" textAnchor="middle" fill="#E8EDDF" fontSize="10" fontWeight="600">CI/CD</text>
                  <text x="290" y="330" textAnchor="middle" fill="#9CA3AF" fontSize="9">Pipeline</text>
                  
                  {/* ISSUE */}
                  <circle cx="385" cy="295" r="22" fill="#242423" stroke="#3A3A38" strokeWidth="2" />
                  <text x="385" y="299" textAnchor="middle" fill="#E8EDDF" fontSize="10" fontWeight="600">ISSUE</text>
                  <text x="385" y="330" textAnchor="middle" fill="#9CA3AF" fontSize="9">Tracking</text>
                  
                </svg>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default AutomotiveFleetUseCase;